import type { Step, StepId } from '../../types';

export const resolveKnownStep = (
  candidate: StepId | undefined,
  steps: Partial<Record<StepId, Step>>,
  fallback: StepId
): StepId => {
  if (candidate && steps[candidate]) {
    return candidate;
  }
  return fallback;
};

export const sanitizeHistory = (history: StepId[] | undefined): StepId[] => {
  if (!Array.isArray(history)) {
    return [];
  }
  return history.filter((step): step is StepId => typeof step === 'string');
};
